<script setup lang="ts">
const props = defineProps({
  criteriaInstance: {
    type: Object as PropType<CriteriaInstance>,
    required: true,
  },
  criteria: {
    type: Object as PropType<ChecklistCriteria>,
    required: true,
  },
});

const documentId = inject("documentId") as any;
const checklistStore = useDocumentChecklistStore(documentId);

const toggleIgnoreStatus = () => {
  if (props.criteriaInstance.isCustom == true) return;

  if (props.criteriaInstance.checklistCriteriaId == undefined) return;

  props.criteriaInstance.ignore = !props.criteriaInstance.ignore;

  checklistStore.saveChecklist();
};
</script>

<template>
  <span class="mr-1">
    <BaseIconButton
      v-tooltip="criteriaInstance.ignore ? 'Include' : 'Ignore'"
      @click.stop="toggleIgnoreStatus"
    >
      <icon :name="criteriaInstance.ignore ? 'mdi:hide' : 'mdi:show'" />
    </BaseIconButton>
  </span>
</template>

<style scoped></style>
